(ns dashboard.services.section
  (:require [re-frame.core :as rf]
            [dashboard.notifications :as notifications]
            [dashboard.services.http-config :as http-config]))

(rf/reg-event-fx
  ::move-section
  (fn [_ [_ questionnaire-id section target-ordinal]]
    {:http-xhrio {:method :post
                  :uri (str "/api/sections/section/" (:id section) "/move")
                  :params {:from (:ordinal section)
                           :to target-ordinal}
                  :timeout http-config/timeout
                  :format http-config/transit-request-format
                  :response-format http-config/transit-response-format
                  :on-success [::move-section-success questionnaire-id]
                  :on-failure [::move-section-failure]}}))

(rf/reg-event-fx
  ::move-section-success
  (fn [{:keys [db]} [_ questionnaire-id new-ordinals]]
    {:db (update-in db [:questionnaires questionnaire-id :sections :data]
                    (fn [sections]
                      (sort-by :ordinal (mapv (fn [{:keys [id] :as section}]
                                                (if (contains? new-ordinals id)
                                                  (assoc section :ordinal (get new-ordinals id))
                                                  section))
                                              sections))))
     :dispatch [::notifications/add {:message "Section moved"}]}))

(rf/reg-event-fx
  ::move-section-failure
  (fn [_ [_ {:keys [response]}]]
    {:dispatch [::notifications/add {:message (:message response)
                                     :class "is-danger"}]}))
